import { fetchConfig, debounce } from '../js/global-exports.js';

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItemsCustomElement = window.isB2cSite === true ? 'cart-items' : 'cart-items-b2b';
            this.closest(cartItemsCustomElement).updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

        this.currentItemCount = this.getCurrentItemCount();

        this.debouncedOnChange = debounce((event) => {
            // should not be triggered by changes to message field in popup.
            if(event.target.id && event.target.id === 'cart-product__note-textarea'){ return; }
            this.onChange(event);
        }, 300);
        document.addEventListener('b2cRefreshCartNoReload',()=>{this.refreshCartNoReload();})

        this.addEventListener('change', this.debouncedOnChange.bind(this));
        if(window.isB2cSite === true) {
            this.preventEnterSubmit();
            this.addEventListener('addAdditionalSalesProducts',(e)=>{ this.updateOnAddAdditionalSalesProducts(e); })
        }
    }
    getCurrentItemCount(){
        return Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    }

    refreshCartNoReload() {
        fetch('/cart')
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, 'text/html');
            this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                const elementToReplaceWith =
                doc.getElementById(section.id).querySelector(section.selector) || doc.getElementById(section.id);

                elementToReplace.innerHTML = elementToReplaceWith.innerHTML;
            }));
        })
    }

    /**
     * Prevent form from submitting when user hits enter in an input field
     */
    preventEnterSubmit(){
        const cartForm = this.querySelector('#cart');
        cartForm.addEventListener('keydown', (event)=> {
        if (event.key === 'Enter') {
            const active = document.activeElement;
            // Prevent Enter only in inputs
            if (active.tagName === 'INPUT' && (active.getAttribute('form') === undefined || active.getAttribute('form') !== 'automatic_gift_password_form')) {
                event.preventDefault();
                if(active.classList.contains('quantity__input')){
                    active.blur();
                }
            }
        }
    });
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    updateOnAddAdditionalSalesProducts(e) {
        this.additionalSalesProductJustAdded = e.detail.variantId;
        this.updateQuantity(1, null, undefined);
    }

    getSectionsToRender() {
        let mainCartFooterSelector = '.js-cart-footer';
        if(window.isB2bSite === true) {
            mainCartFooterSelector = '#main-cart-footer';
        }
        let sectionsToRender = [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: mainCartFooterSelector
            }
        ];
        if(window.isB2cSite === true || document.querySelector('.shipping-notification-text')) {
            sectionsToRender.push({
                id: 'shipping-notification',
                section: 'shipping-notification',
                selector: '.shipping-notification-text'
            });
        }

        return sectionsToRender;
    }

    async updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
        let errors = null;
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then(async(state) => {
            const parsedState = JSON.parse(state);
            if(parsedState.errors) {
                errors = parsedState.errors;
            }
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) {
                cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            }
            this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
            if(window.isB2bSite === true) {
                this.lastOperationType = 'quantity';
            }else if (window.isB2cSite === true){
                if(quantity === 0){
                    this.lastOperationType = 'removal';
                }
            }

            document.getElementById('cart-errors').textContent = '';
            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem =  document.getElementById(`CartItem-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
            if(window.isB2bSite === true) {
                await this.checkIfProductDeliveryDateIsDifferentFromDateStoredInCart();
            }
            this.disableLoading();
        }).catch(() => {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            // if it's a qty error no need to also show the general error message, just the one by the cart line is fine
            if(window.cartStrings.quantityError === null){
                document.getElementById('cart-errors').textContent = window.cartStrings.error;
            }
            this.updateLiveRegions(line, quantity, errors);
            this.disableLoading();
        });
    }

    updateLiveRegions(line, itemCount, errors = null) {
        if(window.isB2bSite === true) {
            this.updateProfits();
            this.initSubmitCheck();
            this.checkOrderDeliveryStatus();
        }
        const itemCountInt = parseInt(itemCount,10)

        const existingErrorMessagesAdditionalSalesProducts = document.getElementsByClassName('cart-item__error--additional-sales-product')
        for (let i = 0; i < existingErrorMessagesAdditionalSalesProducts.length; i++) {
            const element = existingErrorMessagesAdditionalSalesProducts[i];
            element.remove();
        }

        if(this.additionalSalesProductJustAdded){
            const additionalSalesProductItem = document.querySelector(`cart-product[data-variant-product-id="${this.additionalSalesProductJustAdded}"]`);
            let errorMessageTemplate = document.querySelector('.cart-item__error');
            if(additionalSalesProductItem && errorMessageTemplate){
                // show error message for additional product
                errorMessageTemplate = errorMessageTemplate.cloneNode(true);
                errorMessageTemplate.classList.add('cart-item__error--additional-sales-product')
                errorMessageTemplate.querySelector('.cart-item__error-text').innerText = window.cartStrings.soldOut;

                document.getElementById('cart-errors').textContent = window.cartStrings.error;
                additionalSalesProductItem.prepend(errorMessageTemplate)
            }
            this.additionalSalesProductJustAdded = null;
        }else{
            // compare old cart amount with new
            if (((this.lastOperationType === 'quantity' && window.isB2bSite === true) || window.isB2cSite === true) && this.currentItemCount === itemCountInt) {
                if(this.lastOperationType === 'removal'){
                    this.lastOperationType =null;
                }else{
                    document.getElementById(`Line-item-error-${line}`)
                    .querySelector('.cart-item__error-text')
                    .innerHTML = window.cartStrings.quantityError.replace(
                        '[quantity]',
                        document.getElementById(`Quantity-${line}`).value
                    );
                }
            }
            if(errors) {
                document.getElementById(`Line-item-error-${line}`)
                    .querySelector('.cart-item__error-text')
                    .innerHTML = errors;
            }
        }

        this.currentItemCount = itemCountInt;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        document.getElementById('main-cart-items').classList.add('cart__items--disabled');
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
        document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    }
}

customElements.define('cart-items', CartItems);


class CartItemsB2b extends CartItems {
    constructor() {
        super();
        this.lastOperationType = null;
        this.noteInProgress = false;
        this.hasProfitRegion = document.querySelector('.cart__profits') !== null;

        this.addEventListener('addAdditionalSalesProducts',()=>{this.refreshCartNoReload();})

        this.updateProfits();
        this.checkOldDeliveryDates();
        this.checkOrderDeliveryStatus();
        this.conceptNoteText = this.getAttribute('data-concept-text');
        this.initSubmitCheck();
        this.pageShowCalled = false;
        // if latest date-modal has been accepted, don't show it again, just submit
        this.doNotShowModalOnSubmit = false;
        window.addEventListener('pageshow', ()=>{
            this.pageShowCalled = true;//to stop settimeout function to keep running in postponeSubmit if you go history back to cart in safari
            this.submitStarted = false;
        });
        window.addEventListener('load', ()=>{
            this.pageShowCalled = false;
        });
        this.initMoveItemsToOriginalDate();
    }

    /**
     * if all items have been set to ship on latest
     * possible date, provide option to set items
     * back to their earliest shipping date
     */
    initMoveItemsToOriginalDate(){
        const moveButton = this.querySelector('[move-items-to-original-date]');
        if(moveButton){
            moveButton.addEventListener('click',async ()=>{
                await this.updateMultipleDeliveryDates('originalProductDate');
            })
        }
    }

    checkOrderDeliveryStatus() {
        const hasShippingTodayItems = this.querySelector('[data-shipping-status="today"]');
        const hasShippingInFutureItems = this.querySelector('[data-shipping-status="future"]');

        let statusScore = 0;
        if(hasShippingInFutureItems) {
            statusScore += 1;
        }
        if(hasShippingTodayItems) {
            statusScore += 2;
        }

        let deliveryStatus = '';
        if(statusScore === 3) {
            deliveryStatus = 'Mixed'
        }else if(statusScore === 2) {
            deliveryStatus = 'StockOrder'
        }else if(statusScore === 1) {
            deliveryStatus = 'PreOrder'
        }
        this.querySelector('#order-stock-type-field').value = deliveryStatus;
    }

    /**
     * do not submit directly if:
     * * a note has not been saved on the cart
     * * there are multiple shipping dates in the cart and this has not been accepted
     * @param {Event} e
     */
    async postponeSubmit(e) {
        if(!this.doNotShowModalOnSubmit){
            e.preventDefault();

            this.freezeCart();
            this.submitStarted = true;
            const submitBtn = document.getElementById('checkout');
            if(submitBtn) {
                submitBtn.classList.add('loading');
            }
            if(this.noteInProgress) {
                if( !this.pageShowCalled){
                    await setTimeout(()=>{this.postponeSubmit(e)},200)
                }else{
                    this.pageShowCalled = false;
                }
            }else{
                let doSubmit = null;
                if (!this.doNotShowModalOnSubmit){
                    doSubmit = await this.shippingChoiceIfMultipleDates();
                }
                if (doSubmit || this.doNotShowModalOnSubmit) {
                    this.checkOrderDeliveryStatus();
                    this.checkForConceptItems(e,false);
                    this.doNotShowModalOnSubmit = true;
                    // has to run after js thread has finished, or submit will never happen when dates in cart are the same (this is the reason for the setTimeout):
                    setTimeout(()=>{
                        document.getElementById('checkout').click();
                    });
                }
                else{
                    this.freezeCart(false);
                }
            }
        }
    }

    getLatestShippingAndHasMultipleDates(){
        const cartItems = this.getElementsByClassName('cart-item') || [];
        let latestDate = null;
        let differentDates = [];
        let hasDifferentDates = false;
        for (let i = 0; i < cartItems.length; i++) {
            const item = cartItems[i];
            const currDeliveryDate = item.dataset.deliveryDate;
            if(currDeliveryDate !== undefined) {
                const currJsDeliveryDate = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(currDeliveryDate);
                if(latestDate === null || currJsDeliveryDate > latestDate){
                    latestDate = currJsDeliveryDate;
                }
                if(hasDifferentDates === false) {
                 if(differentDates.indexOf(currJsDeliveryDate) == -1) {
                    differentDates.push(currJsDeliveryDate)
                 }
                 if(differentDates.length>1){
                    hasDifferentDates = true;
                 }
                }
            }
        }
        return {hasDifferentDates:hasDifferentDates,latestDate:latestDate}
    }

    /**
     * Show modal with options for changing shipping date
     * @param {date as integer} latestDate
     * @returns promise when a choice has been made in the modal
     */
    async showShippingDateModal(latestDate){
        return new Promise((resolve) => {
            const longDateTextElement = document.getElementById('latest-shipping-date-long');
            const shortDateTextElement = document.getElementById('latest-shipping-date-short');
            if(!longDateTextElement || !shortDateTextElement ){
                console.error('Could not find latest shipping date field(s), maybe due to translation missing.');
                return false;
            }
            longDateTextElement.innerText = Novicell.formatter.dateToHumanShortTextFormat(latestDate);
            shortDateTextElement.innerText = Novicell.formatter.dateToHumanShortTextFormat(latestDate);
            const confirmDialog = document.getElementById('PopupModal-shipping-dates-modal');

            confirmDialog.addEventListener(
                'close',
                () => {
                    resolve(confirmDialog.returnValue);
                },
                { once: true } // remove listener after one use
            );
            confirmDialog.showModal();
        });
    }

    /**
     * handle opening shipping modal and handle reponse
     * @returns true or false depending on whether the user can be sent to checkout after
     */
    async shippingChoiceIfMultipleDates() {
        const { hasDifferentDates, latestDate } = await this.getLatestShippingAndHasMultipleDates();
        if (hasDifferentDates === true) {
            const shipLatest  = await this.showShippingDateModal(latestDate);
            if (shipLatest === 'yes-use-latest-date') {
                // User chose to ship everything on latest date
                await this.updateMultipleDeliveryDates('specificDate',latestDate)
                return true;
            }
            else if (shipLatest === 'no-use-multiple-dates') {
                // User chose to keep separate dates
                return true;
            } else {
                // User cancelled submit
                return false;
            }
        }else {
            // User does not have different dates in cart
            return true;
        }
    }

    initSubmitCheck(){
        const cartForm = this.querySelector('#cart');
        cartForm.addEventListener('submit', async (e)=>{
            await this.postponeSubmit(e);
        });

        cartForm.addEventListener('keypress', function(e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
    }

    async checkForConceptItems(e, onload){
        const hasConceptItem = this.querySelector('.cart-item[data-concept-item]');
        const currentNoteInBrowser = document.querySelector('textarea[name="note"]');
        const currentNoteHasConceptText = currentNoteInBrowser.value.indexOf(this.conceptNoteText) !== -1;
        let changeValue = false;
        if(onload || !hasConceptItem){
            if(currentNoteHasConceptText) {
                currentNoteInBrowser.value = currentNoteInBrowser.value.replaceAll('\r\n'+this.conceptNoteText,'')
                currentNoteInBrowser.value = currentNoteInBrowser.value.replaceAll('\n'+this.conceptNoteText,'')
                if(currentNoteInBrowser.value === this.conceptNoteText){
                    currentNoteInBrowser.value = '';
                }
                changeValue = true;
            }
        }else{
            if(!currentNoteHasConceptText) {
                currentNoteInBrowser.value = currentNoteInBrowser.value + '\r\n' + this.conceptNoteText;
                changeValue = true;
            }
        }

        if(changeValue){
            const body = JSON.stringify({ note: currentNoteInBrowser.value});
            await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).then(()=>{return true;})
            .catch((errorMsg) => {
                console.error(new Error(`clear cart before update failed: ${errorMsg}`));
                e.preventDefault();
                return false;
            });
        }
    }
    /**
     * Check if cart line properties have delivery dates which are in the past (older than today)
     */
    checkOldDeliveryDates(){
        const cartItems = this.getElementsByClassName('cart-item');
        const jsDateToday = Novicell.formatter.nowToJsValueFormat();
        let hasOlderDates = false;

        for (let i = 0; i < cartItems.length; i++) {
            const item = cartItems[i];
            const currDeliveryDate = item.dataset.deliveryDate;
            if(currDeliveryDate !== undefined) {
                const currJsDeliveryDate = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(currDeliveryDate);
                if(currJsDeliveryDate < jsDateToday){
                    hasOlderDates = true;
                    break;
                }
            }
        }

        if(hasOlderDates) {
            this.updateMultipleDeliveryDates('updateDatesFromPast');
        }
    }

    freezeCart(justDoIt){
        const cartDisabler = document.getElementById('cart-disabler');
        if(!cartDisabler) {return;}
        if(justDoIt) {
            cartDisabler.setAttribute('disabled','disabled');
        }else{
            cartDisabler.removeAttribute('disabled');
            const submitBtn = document.getElementById('checkout');
            if(submitBtn) {
                submitBtn.classList.remove('loading');
            }
        }
    }

    /**
     *
     * @param {string} updateType, possible values:
     *  * 'updateDatesFromPast': used when one or more items have a shipping date older than today; needs a newer date
     *  * 'specificDate': used to set shipping date to a specific date (latest) for all cart items (date is the newDate param)
     *  * 'originalProductDate': when shipping date has been set to a specific/latest date, this is the option to set them back to what shipping date the real product has now
     *  * 'originalShippingDateHasChanged': used when one or more items have a shipping date that does not correspong with the 'real' one
     * @param {date as integer} newDate . Optional. Only used when updateType == 'specificDate'
     */
    async updateMultipleDeliveryDates(updateType = 'originalShippingDateHasChanged',newDate = null){
        const jsDateToday = Novicell.formatter.nowToJsValueFormat();
        this.freezeCart(true);

        let newCartItems = [];
        let isUpdateToLatestDateBeforeProceedingToCheckout = false;

        await fetch('/cart.js').then(res => res.json()).then(async (cart) => {
            for (let i = 0; i < cart.items.length; i++) {
                const item = cart.items[i];
                let obj = {};
                // make it into a string or API call will fail
                obj.id = item.id.toString();
                obj.quantity = item.quantity;
                let tempProperties = item.properties;

                const cartLineItemElement = document.querySelector(`[data-lineitem-product-id="${item.id}"]`);
                const currentNaturalDate = cartLineItemElement.getAttribute('data-natural-delivery_date');
                if (updateType == 'updateDatesFromPast') {
                    const jsItemCurrentDate = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(tempProperties.delivery_date);
                    // if date on property is older than today,
                    if(jsDateToday > jsItemCurrentDate){
                    const prodStatus = cartLineItemElement.getAttribute('data-status');
                        if (prodStatus == 'NowDelivery'){
                            // change to today
                            tempProperties.delivery_date = Novicell.formatter.nowToHumanNumberFormat();
                        }else{
                            // when preorder or backorder change to natural delivery date
                            tempProperties.delivery_date = currentNaturalDate;
                        }
                    }
                } else if (updateType == 'specificDate') {
                    // set all items to specific date
                    const dateInHumanNumberFormat = Novicell.formatter.dateToHumanNumberFormat(newDate);
                    if(tempProperties.delivery_date !== dateInHumanNumberFormat){
                        tempProperties.delivery_date = dateInHumanNumberFormat;
                    }
                    isUpdateToLatestDateBeforeProceedingToCheckout = true;
                } else if (updateType == 'originalProductDate') {
                    tempProperties.delivery_date = currentNaturalDate;
                } else if (updateType == 'originalShippingDateHasChanged') {
                    // if date on product tag has changed since adding product to cart, then update cart property
                    const itemDeliveryDateFromProperty = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(tempProperties.delivery_date);
                    const itemDeliveryDateFromProductTag = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(currentNaturalDate);
                    if (itemDeliveryDateFromProperty < itemDeliveryDateFromProductTag) {
                        tempProperties.delivery_date = currentNaturalDate;
                    }
                }

                obj.properties = tempProperties;
                newCartItems.push(obj);
            }
            await this.clearCartAndAddItemsAgain(newCartItems,isUpdateToLatestDateBeforeProceedingToCheckout);
        });
    }

    async clearCartAndAddItemsAgain(newCartItems,isUpdateToLatestDateBeforeProceedingToCheckout){
        const arrNewDatesItems = { items: newCartItems };

        const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
        if (!clearRes.ok) throw new Error(`Clear failed: ${clearRes.status}`);
        await clearRes.json();

        const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(arrNewDatesItems)
        });
        if (!addRes.ok) throw new Error(`Add failed: ${addRes.status}`);
        await addRes.json();

        if (!isUpdateToLatestDateBeforeProceedingToCheckout){
            location.reload();
        }
    }

    onChange(event) {
        if(event.target.dataset.index !== undefined) {
            document.getElementById(`Quantity-${event.target.dataset.index}`).value = event.target.value;
            this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
        }
    }

    refreshCartNoReload() {
        fetch('/cart')
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, 'text/html');
            this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                const elementToReplaceWith =
                doc.getElementById(section.id).querySelector(section.selector) || doc.getElementById(section.id);

                elementToReplace.innerHTML = elementToReplaceWith.innerHTML;
            }));

            this.updateProfits();
            this.freezeCart(false);
        });
    }

    /**
     * Check if product delivery dates stored on cart line items are different than the delivery date coming from product tags
     */
    async checkIfProductDeliveryDateIsDifferentFromDateStoredInCart(){
        const cartItems = this.getElementsByClassName('cart-item') || [];
        let datesOutOfSync = false;

        for (const item of cartItems) {
            const itemDeliveryDateFromProperty = item.getAttribute('data-delivery-date') || '';
            const itemDeliveryDateFromProductTag = item.getAttribute('data-natural-delivery_date') || '';
            const itemDeliveryDateFromPropertyFormatted = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(itemDeliveryDateFromProperty);
            const itemDeliveryDateFromProductTagFormatted = Novicell.formatter.dateGetJsValueFromHumanNumberFormat(itemDeliveryDateFromProductTag);
            if (itemDeliveryDateFromPropertyFormatted < itemDeliveryDateFromProductTagFormatted) {
                datesOutOfSync = true;
                break
            }
        }
        if(datesOutOfSync) {
            await this.updateMultipleDeliveryDates('originalShippingDateHasChanged')
        }
    }

    updateProfits(){
        const cartTotalHolder = document.getElementById('cart-totals-value');
        const rrpDataHolder = document.getElementById('cart-total-rrp');
        if(!cartTotalHolder || !rrpDataHolder) {return;}

        const rrpFormattedAttribute = rrpDataHolder.dataset.totalRrpFormatted;
        cartTotalHolder.setAttribute('data-price-retail','RRP: '+rrpFormattedAttribute)

        if(this.hasProfitRegion) {
            const rrpAttribute = parseInt(rrpDataHolder.dataset.totalRrp,10);
            const cartTotalAttribute = parseInt(rrpDataHolder.dataset.cartTotal,10);
            const profitsRrpHolder = document.getElementById('cart-profits-rrp');
            const profitsTotalProfitsHolder = document.getElementById('cart-profits-total-profit');
            const profitsMarkupHolder = document.getElementById('cart-profits-markup');

            if(!profitsRrpHolder || !profitsTotalProfitsHolder || !profitsMarkupHolder) {return;}

            profitsRrpHolder.innerText = rrpFormattedAttribute;

            const profitsTotalFormatted = Shopify.formatMoney(rrpAttribute - cartTotalAttribute, moneyFormatWithCurrency);
            profitsTotalProfitsHolder.innerText = profitsTotalFormatted;

            const markUp = rrpAttribute / cartTotalAttribute;
            profitsMarkupHolder.innerText = Novicell.formatter.formatNumberMaxDecimals(markUp,1);
        }
    }

    initNoteField(noteField) {
        noteField.addEventListener('change', (event)=>{this.onChangeNote(event);});
    }

    async onChangeNote(event){
        setTimeout(()=>{
            if(this.submitStarted){return;}
            this.noteInProgress = true;
            const body = JSON.stringify({ note: event.target.value });
            let fetchedConfig = fetchConfig();
            if(!fetchedConfig.headers['Content-Type'] || fetchedConfig.headers['Content-Type'] === ''){
                fetchedConfig.headers['Content-Type'] = 'application/json'
            }

            fetch(`${routes.cart_update_url}`, {...fetchedConfig, ...{ body }}).catch((error) => {
                console.error(error)
            });
            this.noteInProgress = false;
        })
    }
}

customElements.define('cart-items-b2b', CartItemsB2b);
